import get from 'lodash/get';
import {wix} from 'chat-widget-common';

export const shouldResizeBeforeRender = (state, nextState) => {
  const visibleChanged = state.visible !== nextState.visible;
  const collapsedChanged = state.collapsed !== nextState.collapsed;
  const roundedChanged = state.rounded !== nextState.rounded;

  if (visibleChanged) {
    return nextState.visible;
  }
  if (collapsedChanged) {
    return !nextState.collapsed;
  }
  if (roundedChanged) {
    return !nextState.rounded;
  }
};
const resizeToCollapsedMode = asRounded => asRounded ?
  wix.resizeWindow(90, 90) : wix.resizeWindow(300, 55);

const resizeToExpandedMode = () => wix.resizeWindow(376, 515);

export const resizeWindow = ({chatVisible, collapsed, chatSettings}) => {
  if (chatVisible) {
    collapsed ? resizeToCollapsedMode(get(chatSettings, 'layout.collapsedAsRounded')) : resizeToExpandedMode();
  } else {
    wix.resizeWindow(0, 0);
  }
};



// WEBPACK FOOTER //
// ./chat-app/services/resizeContainer.js